import { useDispatch } from "react-redux";
import { editBook } from "../redux/books/actions";
import remover from "../redux/books/thunk/remover";

const numberofRating = (rating) => {
  switch (rating) {
    case 1:
      return (
        <div className="lws-stars">
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
        </div>
      );
    case 2:
      return (
        <div className="lws-stars">
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
        </div>
      );
    case 3:
      return (
        <div className="lws-stars">
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
        </div>
      );
    case 4:
      return (
        <div className="lws-stars">
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054ZM12.472 11.32 2.369 12.772l7.305 7.01-1.717 9.89L17 25.012l9.042 4.66-1.716-9.89 7.305-7.01-10.103-1.452L17 2.328l-4.528 8.992Z" />
          </svg>
        </div>
      );
    case 5:
      return (
        <div className="lws-stars">
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
          <svg
            viewBox="0 0 35 35"
            fill="currentColor"
            className="lws-star"
          >
            <path d="M18.05.242c.466.226.843.596 1.073 1.054L23.1 9.194l8.874 1.276c1.294.186 2.19 1.368 2 2.64a2.313 2.313 0 0 1-.688 1.327l-6.416 6.157 1.507 8.687c.22 1.267-.647 2.47-1.936 2.685a2.406 2.406 0 0 1-1.499-.233L17 27.64l-7.942 4.093c-1.159.597-2.59.159-3.198-.98a2.292 2.292 0 0 1-.238-1.472l1.508-8.687-6.416-6.157a2.299 2.299 0 0 1-.04-3.29 2.384 2.384 0 0 1 1.352-.677L10.9 9.194l3.977-7.898c.58-1.152 2-1.624 3.173-1.054Z" />
          </svg>
        </div>
      );
    default:
      return 0;
  }
};

export default function Book({ book }) {
  const dispatch = useDispatch();
  const { id, name, author, thumbnail, price, rating, featured } = book;

  //dispatch action for edit book details
  const handleEdit = () => {
    dispatch(editBook(book));
  };

  //dispatch action for delete book
  const handleDelete = (id) => {
    dispatch(remover(id));
  };

  return (
    <div className="book-card">
      <img
        className="h-[240px] w-[170px] object-cover lws-bookThumbnail"
        src={thumbnail}
        alt="book"
      />
      <div className="flex-1 h-full pr-2 pt-2 flex flex-col">
        <div className="flex items-center justify-between">
          {featured ? (
            <span className="badge-success lws-Badge">featured</span>
          ) : (
            <span></span>
          )}
          <div className="text-gray-500 space-x-2">
            <button
              className="lws-edit"
              onClick={handleEdit}
            >
              <svg
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                />
              </svg>
            </button>
            <button
              className="lws-delete"
              onClick={() => handleDelete(id)}
            >
              <svg
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="space-y-2 mt-4 h-full">
          <h4 className="lws-bookName">{name}</h4>
          <p className="lws-author">{author}</p>
          {numberofRating(rating)}
          <p className="lws-price">USD {price}</p>
        </div>
      </div>
    </div>
  );
}
